const padHexString = hexString => {
  return hexString.padStart(64, "0").slice(0, 64);
};

export { padHexString };
